module.exports = __webpack_public_path__ + "img/fileUpload.19150587.jpg";